/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Box, Grid, Paper, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import apiChallenge from '@reducers/challenge/api'
import ChallengeDispatcher from '@reducers/challenge/dispatcher'
import { ReduxState } from '@reducers/index'
import modalActions from '@reducers/modal/actions'
import { MODAL_TYPES } from '@reducers/modal/types'
import TeamDispatcher from '@reducers/teams/dispatcher'
import _, { isEmpty } from 'lodash'
import React, { useCallback, useState } from 'react'
import ReactHlsPlayer from 'react-hls-player'
import { useAsyncFetch } from 'react-hooks-async-handlers'
import { useDispatch, useSelector } from 'react-redux'
import { RendererStatusSplit } from 'react-renderer-status-split'
import ButtonOrange from '../../components/ButtonOrange'
import Container from '../../components/Container'
import ReactionLoader from '../../components/ReactionLoader'
import Asset from '../../components/assets/Asset'
import Charts from '../groups/groups/Charts'
import LeaderboardListSteps from '../leaderboard/leaderboards/LeaderboardListSteps'
import Challenge from './components/Challenge'
import CompaniesLeaderBoard from './components/companiesLeaderboard/CompaniesLeaderBoard'
import StepsPath from './path/StepsPath'
import SquatIcon from '../groups/assets/squat-challenge.png'
import StepIcon from '../groups/assets/step-challenge.png'
import config from '../../config'
import { useHistory } from 'react-router-dom'
import ScoreIcon from '../groups/assets/score-challenge.png'
import MediationIcon from '../groups/assets/mediation-challenge.png'
import PhotoIcon from '../groups/assets/photo-challenge.png'
import BreathIcon from '../groups/assets/breathing-challenge.png'
import PlankIcon from '../groups/assets/plank.png'
import RunIcon from '../groups/assets/run-challenge.png'
import { arrowBackIcon } from '../../components/paperContainer/assets/facade'
import BreathingPicture from './assets/breathing.png'
import PlankPicture from './assets/plank-picture.png'
import MeditationPicture from './assets/mediation.png'
import PicturePicture from './assets/picture.png'
import RunCrewPicture from './assets/run-crew.png'
import ScorePicture from './assets/score.png'
import squatsIcon from '../groups/assets/squats-icon.png'
import stepsIcon from '../groups/assets/steps-icon.png'
import { RemoveChallenge } from '../groups/RemoveChallenge'
import breathIcon from '../groups/assets/breath-icon.svg'
import plankIcon from '../groups/assets/plank-icon.svg'
import { secondsToTime } from '../../helpers/utils'
import moment from 'moment-timezone'

interface Props {
  match: any
}

const spacing = 5

const cssSeparator = css`
  height: 1px;
  background-color: rgba(89, 88, 88, 1);
  width: 100%;
  margin: 0 0 20px;
`

const cssBanner = css`
  background-color: #e9e9e9;
  margin: 15px -30px 50px;
  padding: 15px 30px;
`

const useStyles = makeStyles({
  image: {
    width: 100,
    height: 100,
    borderRadius: 5,
  },
  content: {
    borderTop: '1px solid #E2DFDF',
    marginTop: 55,
  },
  backImage: {
    width: 7,
    height: 13,
    marginRight: 15,
  },
  backText: {
    fontSize: 14,
    color: '#000',
    lineHeight: '100%',
  },
  backContainer: {
    cursor: 'pointer',
  },
  challengeImage: {
    maxWidth: '100%',
  },
  icon: {
    width: 32,
    marginRight: 20,
  },
  title: {},
  bannerTitle: {
    display: 'flex',
    alignItems: 'center',
  },
})

const challengesSettings = {
  steps: {
    title: 'Steps challenge',
    by: 'Reaction',
    description:
      'Choose a start date and duration, then invite your team to join an engaging and inclusive step challenge. Members can effortlessly sync their step data from Android, iPhone, or wearable devices and compete daily to achieve the highest average step count.',
    icon: StepIcon,
  },
  squats: {
    title: 'Squats challenge',
    by: 'Fittyai',
    description:
      "As you add the squat challenge, your team can join it through the programs section of the Reaction Club app. By default, the challenge runs weekly from Monday 00:00 to Sunday 23:59. After integrating the challenge, you can adjust the duration, set a start date, and set up team competitions. Members can log squats using advanced AI motion-tracking technology and compete for the highest daily average. Let's get started!",
    icon: SquatIcon,
    video: (
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/5RGchXuEs5E?si=_aLJYzHTZCVbM0wj"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    ),
    isPremium: true,
  },
  'score-predication': {
    title: 'Score prediction',
    by: 'Reaction',
    description:
      'In this activity, your team selects a major event like the football World Cup, Eurovision, or Super Bowl. Team members make predictions about the event and earn points for their guesses. Each day, members receive personal daily goals and earn points for achieving them while supporting colleagues.',
    icon: ScoreIcon,
    comingSoon: true,
    type: 'score-predication',
    image: ScorePicture,
  },
  mediation: {
    title: 'Meditation Club',
    by: 'Reaction',
    description:
      'Create a Meditation Club to provide your team with access to expert-guided meditations. Members can measure their meditation minutes, earn points for practice, share their experiences, and motivate colleagues to make progress.',
    icon: MediationIcon,
    comingSoon: true,
    type: 'mediation',
    image: MeditationPicture,
  },
  pictures: {
    title: 'Pictures challenge',
    by: 'Reaction',
    description:
      'Promote daily creativity with our Pictures Challenge. Members receive a unique daily prompt on the app and respond with pictures or short text. Engage in a fun and anonymous rating system and contribute to a vibrant collage of joy and happiness through pictures.',
    icon: PhotoIcon,
    comingSoon: true,
    type: 'pictures',
    image: PicturePicture,
  },
  breath: {
    title: 'Breathing routine ',
    by: 'Reaction',
    description:
      "Encourage your team to prioritize wellbeing with our Breathing Routine activity. Members will receive a short guided breathing break to incorporate into their daily routines. They'll earn points as they meet their break goals and inspire colleagues to take relaxing breaks. This initiative helps foster a consistent relaxation routine, promoting overall health and balance.",
    icon: BreathIcon,
    type: 'breathing-routine',
    image: BreathingPicture,
    isPremium: true,
  },
  plank: {
    title: 'Planking routine ',
    by: 'Reaction',
    description:
      'The workplace plank challenge app is designed to make fitness both fun and competitive. Using innovative AI motion tracking technology, the app not only records your daily plank times accurately but also offers personalized coaching to ensure members are planking correctly. Set a start date and duration to challenge your team',
    icon: PlankIcon,
    type: 'plank',
    image: PlankPicture,
    isPremium: true,
  },
  'run-crew': {
    title: 'Run Crew',
    by: 'Reaction',
    description:
      'Create a Workplace Run Crew where members set running goals, follow training programs, record runs, and compete for the top spot on the distance leaderboard. Earn points for achieving goals, sharing runs, and supporting colleagues',
    icon: RunIcon,
    comingSoon: true,
    type: 'run-crew',
    image: RunCrewPicture,
  },
}

const getIcon = (type) => {
  if (type === 'squats') {
    return squatsIcon
  } else if (type === 'breath') {
    return breathIcon
  } else if (type === 'plank') {
    return plankIcon
  } else {
    return stepsIcon
  }
}

const Dashboard: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const { company } = useSelector((state: ReduxState) => ({
    company: state.company,
  }))
  const history = useHistory()
  const classes = useStyles()
  const { match } = props
  const { id, type: enableType } = match.params || {}
  const [challenge, setChallenge] = useState<any>()

  const handleOpenExportSteps = (type) => () => {
    dispatch(
      modalActions.showModal({
        modalType: MODAL_TYPES.EXPORT_STEPS,
        modalProps: { challengeType: challenge?.type, type },
      }),
    )
  }

  const dataFetchChallengesAction = useAsyncFetch(async () => {
    await dispatch(TeamDispatcher.getList({ isForce: false }))
    const res = await apiChallenge.getChallenge(id)
    setChallenge(res)
  })

  const type = enableType || challenge?.type

  const isFreeTrial = company?.subscriptionPlan?.type === 'FREE_TRIAL'

  const handleSelectChallenge = useCallback(async () => {
    if (isFreeTrial && type !== 'steps') {
      history.push('/payment')
    } else {
      await dispatch(
        ChallengeDispatcher.updateChallenge(type, {
          duration: 7,
          startDate: moment().add(1, 'day').format('YYYY-MM-DD'),
        }),
      )
      history.push('/')
    }
  }, [isFreeTrial])

  const renderFreeTrial = () => {
    return (
      <Paper
        css={css`
          padding: 80px;
          box-shadow: 0px 2px 4px rgba(156, 156, 156, 0.25);
          border-radius: 5px;

          @media (max-width: 520px) {
            margin: 0;
            padding: 10px;
          }
        `}
      >
        <Grid container spacing={spacing}>
          <Grid item>
            <Grid
              container
              direction={'row'}
              alignItems={'center'}
              className={classes.backContainer}
              onClick={history.goBack}
            >
              <img src={arrowBackIcon} alt="back icon" className={classes.backImage} />
              <Typography className={classes.backText}>Back</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item flexBasis={135}>
                <Asset resizeMode={'cover'} className={classes.image} asset={{ url: challengesSettings[type].icon }} />
              </Grid>
              <Grid item flexGrow={1} paddingTop={2}>
                <Typography variant="h1" mb={1} fontWeight="bold" fontSize={21} display="flex" alignItems="flex-end">
                  {challengesSettings[type].title}
                  {challengesSettings[type].isPremium ? (
                    <Typography fontWeight="400" fontSize={18} ml={3}>
                      (Premium)
                    </Typography>
                  ) : null}
                </Typography>
                <Typography fontSize={16} mb={2}>
                  {challengesSettings[type].by ? `By ${challengesSettings[type].by}` : ''}
                </Typography>
                <ButtonOrange
                  color={challengesSettings[type].comingSoon ? '#DADADA' : undefined}
                  onClick={challengesSettings[type].comingSoon ? null : handleSelectChallenge}
                >
                  <Typography textTransform="uppercase" fontWeight="600">
                    {challengesSettings[type].comingSoon
                      ? 'Coming soon'
                      : isFreeTrial && challengesSettings[type].isPremium
                      ? 'Upgrade'
                      : 'Add'}
                  </Typography>
                </ButtonOrange>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.content}>
            <Grid container>
              <Grid item xs={6}>
                <Box mb={7} pr={6}>
                  <Typography mt={2} fontSize={18} lineHeight={1.6}>
                    {challengesSettings[type].description}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                {challengesSettings[type].image ? (
                  <img src={challengesSettings[type].image} className={classes.challengeImage} />
                ) : challengesSettings[type].video ? (
                  challengesSettings[type].video
                ) : (
                  <ReactHlsPlayer
                    src={'https://s.reaction-club.app/-/_/onboarding/Onboarding_stepvideo2.m3u8'}
                    autoPlay={false}
                    controls
                    width="100%"
                    height="auto"
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    )
  }

  if (props.enable) {
    return renderFreeTrial()
  }

  return (
    <RendererStatusSplit
      statuses={dataFetchChallengesAction}
      isEmpty={_.isEmpty(challenge)}
      renderLoading={() => <ReactionLoader marginTop={40} />}
      render={() => {
        if (_.isEmpty(challenge)) {
          return null
        }

        return (
          <Container>
            <Grid container>
              <Grid item>
                <Grid
                  container
                  direction={'row'}
                  alignItems={'center'}
                  className={classes.backContainer}
                  onClick={history.goBack}
                >
                  <img src={arrowBackIcon} alt="back icon" className={classes.backImage} />
                  <Typography className={classes.backText}>Back</Typography>
                </Grid>
              </Grid>
            </Grid>
            <div css={cssBanner}>
              <Grid container justifyContent="space-between">
                <Grid item className={classes.bannerTitle}>
                  <img src={getIcon(challenge.type)} className={classes.icon} />
                  <Typography className={classes.title} fontSize={18} fontWeight="bold">
                    {challenge.name}
                  </Typography>
                </Grid>
                <Grid item>
                  <RemoveChallenge challengeId={challenge.challenge_id} />
                </Grid>
              </Grid>
            </div>
            <Grid container spacing={spacing} alignItems={'stretch'}>
              <Grid item xs={12}>
                <Grid container spacing={6}>
                  <Challenge type="current" challenge={challenge} />
                  <Challenge type="future" challenge={challenge} />
                </Grid>
              </Grid>
              {isEmpty(challenge.dailyReports) ? null : (
                <Grid item xs={12} maxHeight={500} pb={20}>
                  <div css={cssSeparator} />
                  <Typography fontWeight="bold" fontSize={16}>
                    Daily average {type}
                  </Typography>
                  <Typography fontSize={12}>Per member</Typography>
                  <Typography mb={4} fontSize={24}>
                    {challenge.type === 'breath' || challenge.type === 'plank'
                      ? secondsToTime(challenge.valueAvg)
                      : challenge.valueAvg || 0}
                  </Typography>

                  <Charts type={challenge.type} details={challenge.dailyReports || []} maxBars={20} />
                </Grid>
              )}

              <React.Fragment>
                <Grid xs={12} item>
                  <div css={cssSeparator} />
                </Grid>
                <Grid item flexGrow={1}>
                  <CompaniesLeaderBoard type={challenge.type} />
                </Grid>
              </React.Fragment>

              <Grid item>{challenge.type === 'steps' ? <StepsPath challenge={challenge} /> : null}</Grid>

              <Grid item xs={12}>
                <div css={cssSeparator} />
                <Grid container alignItems={'center'}>
                  <Grid container sm={6} justifyContent={'space-between'}>
                    <Typography variant={'h1'} mr={20}>
                      Leaderboard
                    </Typography>
                  </Grid>
                  <Grid sm={6} container justifyContent="flex-end">
                    <ButtonOrange onClick={handleOpenExportSteps('users')} styles={{ marginRight: 5 }} locked>
                      Export members data
                    </ButtonOrange>
                    <ButtonOrange onClick={handleOpenExportSteps('teams')} locked>
                      Export teams data
                    </ButtonOrange>
                  </Grid>
                </Grid>

                <Box pt={4}>
                  <LeaderboardListSteps challenge={challenge} isFreeTrial={isFreeTrial} />
                </Box>
              </Grid>
            </Grid>
          </Container>
        )
      }}
    />
  )
}

export default Dashboard
